module.exports = __webpack_public_path__ + "img/hint-five-mobile.3bc9f192.png";